import { render, staticRenderFns } from "./Requirement.vue?vue&type=template&id=05905bc2"
import script from "./Requirement.vue?vue&type=script&lang=js"
export * from "./Requirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports